// assets

import ContactsIcon from '@mui/icons-material/Contacts';
// icons
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import { ApartmentOutlined,ContactsOutlined } from '@ant-design/icons';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BadgeIcon from '@mui/icons-material/Badge';
import WorkIcon from '@mui/icons-material/Work';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';

// icons
const icons = {
    ApartmentOutlined,ContactsOutlined
};
// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const contact = {
  id: 'group-contact',
  title: 'Contact',
  type: 'group',
  children: [
    {
      id: 'contact',
      title: 'Contact',
      type: 'item',
      url: '/contact',
      icon: ContactsIcon,
      breadcrumbs: true
    },
     {
          id: 'contactlist',
          title: 'Contact Lists',
          type: 'item',
          url: '/contactlists',
          icon: ListAltIcon,
          breadcrumbs: true
        },
        {
            id: 'group',
            title: 'Group',
            type: 'item',
            url: '/group',
            icon: GroupsIcon,
            breadcrumbs: true
        },
        {
          id: 'organization-directory',
          title: 'Organization',
          type: 'collapse',
          icon: CorporateFareIcon,
          children: [
            {
              id: 'organizations',
              title: 'Organizations',
              type: 'item',
              url: '/organizations',
              icon: icons.ApartmentOutlined,
              breadcrumbs: true,
            },
            {
              id: 'organizationsreport',
              title: 'Organization Report',
              type: 'item',
              url: '/organizations-report',
              icon: AssessmentIcon,
              breadcrumbs: true,
            },
            {
                id: 'organizationdepartment',
                title: 'Departments',
                type: 'item',
                url: '/organization-department',
                icon: icons.ContactsOutlined,
                breadcrumbs: true
              },

          ]
        },
        {
                id: 'designations',
                title: 'Designations',
                type: 'item',
                url: '/designations',
                icon: BadgeIcon,
                breadcrumbs: true
            },
            {
                  id: 'professions',
                  title: 'Professions',
                  type: 'item',
                  url: '/professions',
                  icon:WorkIcon,
                  breadcrumbs: true
                }
  ]
};

export default contact;
